// LoginIcon.js
import PropTypes from "prop-types";
import colors from "assets/theme/base/colors";

function LoginIcon({ color, size }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      fill={colors[color] ? colors[color].main : colors.dark.main}
    >
      <title>login-icon</title>
      <g>
        <rect fill="none" height="24" width="24"/>
      </g>
      <g>
        <path d="M11,7L9.6,8.4l2.6,2.6H2v2h10.2l-2.6,2.6L11,17l5-5L11,7z M20,19h-8v2h8c1.1,0,2-0.9,2-2V5c0-1.1-0.9-2-2-2h-8v2h8V19z"/>
      </g>
    </svg>
  );
}

// Setting default values for the props of LoginIcon
LoginIcon.defaultProps = {
  color: "dark",
  size: "24px",
};

// Typechecking props for the LoginIcon
LoginIcon.propTypes = {
  color: PropTypes.oneOf([
    "primary",
    "secondary",
    "info",
    "success",
    "warning",
    "error",
    "dark",
    "light",
    "white",
  ]),
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

export default LoginIcon;
